import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';

import { SnTeam } from '@lib/api/entities';

@Component({
  selector: 'sn-team-color',
  template: '',
  styleUrls: ['./team-color.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnTeamColorComponent {
  @Input()
  public team: SnTeam;

  @HostBinding('style.backgroundColor')
  get color(): string {
    return this.team.color;
  }
}
